import {utilHelper} from "../../_helpers";

const relativeUrl = 'api/tag'

export const tagService = {
    getList,
    getItem,
    saveItem,
    updateItem,
    deleteItem,
    getAll,
    getPagedList,
};

function getPagedList(offset, max) {
    return utilHelper.doRequest(`${relativeUrl}?max=${max}&offset=${offset}`, 'GET')
}

function getAll() {
    return utilHelper.doRequest(`${relativeUrl}/getAll`, 'GET')
}

function getList() {
    return utilHelper.doRequest(`${relativeUrl}`, 'GET')
}

function getItem(id) {
    return utilHelper.doRequest(`${relativeUrl}/${id}`, 'GET')
}

function saveItem(data) {
    return utilHelper.doRequest(`${relativeUrl}`, 'POST', data);
}

function updateItem(id, data) {
    return utilHelper.doRequest(`${relativeUrl}/${id}`, 'PUT', data);
}

function deleteItem(id) {
    return utilHelper.doRequest(`${relativeUrl}/${id}`, 'DELETE')
}